import React from 'react';

const GameSummary = ({ summary }) => {
  console.log("Running Through game Summary");
  console.log(summary)

   if (!summary) {
    console.log("Summary is null or undefined");
    return null;
  }

  const accuracyPercentage = summary.words_played > 0
    ? ((summary.correct_answers / summary.words_played) * 100).toFixed(2)
    : 'N/A';

    console.log(accuracyPercentage)

    const wordsLearned = Array.isArray(summary.words_learned) ? summary.words_learned : [];

  return (
    <div className="game-summary">
      <table>
        <tbody>
          <tr>
            <td style={{ width: '100px' }}>Words:</td>
            <td>{summary.words_played}</td>
          </tr>
          <tr>
            <td style={{ width: '100px' }}>Correct:</td>
            <td>{summary.correct_answers}</td>
          </tr>
          <tr>
            <td style={{ width: '100px' }}>Accuracy:</td>
            <td>{accuracyPercentage}%</td>
          </tr>
          </tbody>
      </table>
      <table>
        <tbody>
          <tr>
            <td className="align-top">New Words Learned:</td>
            </tr>
          <tr>
            <td className="align-top">
              <div className="d-flex flex-column">
              {wordsLearned.length === 0 ? (
                  <p className="text-gray-500 italic">N/A</p>
                ) : (
                  wordsLearned.map((item, index) => {
                    if (Array.isArray(item)) {
                      return (
                        <div key={index} className="mb-2 flex">
                          <span className="min-w-[150px] text-blue-600 mr-4">{item[0]}</span>
                          <span>{item[1]}</span>
                        </div>
                      );
                    }

                // Handle if item is a string with ' : ' delimiter
                if (typeof item === 'string') {
                  const [term, definition] = item.split(' : ');
                  return (
                    <div key={index} className="mb-1 d-flex">
                      <span style={{ minWidth: '150px', color: '#4e54c8' }} className="me-4">{term}</span>
                      <span>{definition}</span>
                    </div>
                  );
                }
                return null;
                 })
                )}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default GameSummary;